import { useEffect, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import useRotate from '../../../MediaSection/hooks/useRotate';
import rotateIcon from 'assets/rotate-icon.svg';

function RotateButton({ rotation, style, onVideoWall, isExpanded }) {
    const initialRender = useRef(true);
    const buttonRef = useRef(null);
    const { handleClick, handleMouseDown, handleDoubleClick, handleResetRotation } = useRotate(rotation);

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
            return;
        }
        setTimeout(handleResetRotation, 500);
        // eslint-disable-next-line
    }, [isExpanded]);

    if (onVideoWall) return null;

    return (
        <Tooltip
            title={
                isExpanded ? (
                    <span>
                        Rotate <strong>[Alt + Shift + R]</strong>
                    </span>
                ) : (
                    'Rotate 90° left'
                )
            }
            placement={isExpanded ? 'top' : 'bottom'}
        >
            <img
                ref={buttonRef}
                style={style}
                onClick={handleClick}
                onMouseDown={handleMouseDown}
                onDoubleClickCapture={handleDoubleClick}
                src={rotateIcon}
            />
        </Tooltip>
    );
}

export default RotateButton;
